//
// Your price:
//     Always if ( logged in == true)
//
// Final price:
//     Show: if ( logged in == false)
//     Hide: if ( logged in == true) && (Your price >= final price)
//
// Strike out :
//     Show: if ( logged in == true ) and (Your price < final price)

import { PricingDetails } from "./PricingDetails";

export interface PricingInterface {
    catalogNumber?: string;
    pricingDetails?: PricingDetails;
    pricingServiceError?: boolean;
}

export class PricingModel implements PricingInterface {
    catalogNumber = null;
    pricingDetails = null;
    pricingServiceError = false;

    constructor(data?: PricingInterface) {
        if (data?.catalogNumber) {
            this.catalogNumber = data.catalogNumber;
        }

        if (data?.pricingDetails) {
            this.pricingDetails = data.pricingDetails;
        }

        if (data?.pricingServiceError) {
            this.pricingServiceError = data.pricingServiceError;
        }

    }

    displayMyPrice(isUserLoggedIn: boolean): boolean {
        return isUserLoggedIn && this.pricingDetails?.userPrice != null;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getFinalPrice(isUserLoggedIn: boolean): string {

        if (this.pricingDetails.finalPrice != null) {
            return this.pricingDetails.finalPrice;
        }

        return this.pricingDetails?.message || "Price not available";

    }

    showFinalPrice(isUserLoggedIn: boolean): boolean {

        if (isUserLoggedIn === false) {
            return true;
        }

        return parseFloat(this.pricingDetails?.userPrice) < parseFloat(this.pricingDetails?.finalPrice);

    }

    getStrikeOutPrice(): string {
        return this.pricingDetails?.finalPrice;
    }

    showStrikeOutPrice(): boolean {
        return this.pricingDetails?.finalPrice &&
            (parseFloat(this.pricingDetails?.finalPrice) > parseFloat(this.pricingDetails?.userPrice));
    }

    getPromoEndDate(): string {
        return this.pricingDetails?.specialOfferEndDate || '';
    }

    getSecondBestPrice(): string {
        const secondBestPriceSrc = this.pricingDetails?.secondBestPriceType;
        switch (secondBestPriceSrc?.toUpperCase()) {
            case 'ONLINE':
                return this.pricingDetails?.formattedPrice?.onlinePrice;
            case 'SPECIALOFFER':
                return this.pricingDetails?.formattedPrice?.specialOffer;
            case 'LIST':
                return this.pricingDetails?.formattedPrice?.listPrice;
            case 'ACCOUNT':
                return this.pricingDetails?.formattedPrice?.yourPrice;
            default:
                return '';
        }
    }

    getSavings(): string {

        const finalPrice = this.parseCurrency(this.pricingDetails?.finalPrice);
        const secondBestPrice = this.parseCurrency(this.pricingDetails?.secondBestPrice) || finalPrice;
        const absoluteSavings = this.parseCurrency(this.pricingDetails?.formattedPrice?.absoluteSavings) || 0;
        if (finalPrice && absoluteSavings) {
            const propDiff = absoluteSavings / secondBestPrice;
            return `Save ${(absoluteSavings).toFixed(2)} (${(propDiff * 100).toFixed(0)}%)`;
        }

        return '';
    }

    parseCurrency(priceStr) {
        if (!priceStr) {
            return null;
        }
        // Trim spaces and remove any currency symbols
        let cleaned = priceStr.trim().replace(/[^0-9.,-]+/g, '');

        // Detect the format based on the presence of commas and periods
        const hasComma = cleaned.includes(',');
        const hasDot = cleaned.includes('.');

        if (hasComma && hasDot) {
            // If there are both commas and dots, we assume comma is the thousands separator and dot is the decimal separator
            cleaned = cleaned.replace(/,/g, '');  // Remove all commas (thousands separators)
        } else if (hasComma && !hasDot) {
            // If only commas are present, assume it's a European format where comma is the decimal separator
            cleaned = cleaned.replace(/\./g, ''); // Remove dots (thousands separators)
            cleaned = cleaned.replace(/,/g, '.'); // Replace comma with dot for decimals
        } else if (!hasComma && hasDot) {
            // If only dots are present, it's a US-style number; no need to change
            cleaned = cleaned.replace(/,/g, '');  // Remove any potential commas
        }

        return parseFloat(cleaned);
    }

}



